import { PageLayout } from "@/components/layout/page-layout";
import { Badge } from "@/components/ui/badge";

export default function Privacy() {
  return (
    <PageLayout breadcrumbs={[{ label: "Privacy Policy" }]} showCta={false}>
      <div className="mb-8">
        <Badge variant="secondary" className="mb-4">Legal</Badge>
        <h1 className="text-4xl font-extrabold tracking-tight mb-4">Privacy Policy</h1>
        <p className="text-sm text-muted-foreground">Last updated: February 2025</p>
      </div>

      <div className="prose-sm max-w-3xl space-y-8">
        <section>
          <h2 className="text-xl font-bold tracking-tight mb-3">1. Information We Collect</h2>
          <div className="bg-card border rounded-xl p-5 space-y-3 text-sm text-secondary-foreground leading-relaxed">
            <p>
              LoadLogo collects minimal information necessary to provide and improve our service. This includes:
            </p>
            <ul className="list-disc list-inside space-y-1.5 pl-2">
              <li>API request logs: domain names, ticker symbols, and crypto symbols queried through our API</li>
              <li>Request metadata: IP addresses, user agent strings, and timestamps for rate limiting and abuse prevention</li>
              <li>Account information: email address and payment details if you sign up for a Pro plan</li>
            </ul>
            <p>
              We do not collect personal information from users of the free tier. No signup or account creation is required.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-bold tracking-tight mb-3">2. How We Use Information</h2>
          <div className="bg-card border rounded-xl p-5 space-y-3 text-sm text-secondary-foreground leading-relaxed">
            <ul className="list-disc list-inside space-y-1.5 pl-2">
              <li>To provide and maintain the LoadLogo API service</li>
              <li>To enforce rate limits and prevent abuse</li>
              <li>To improve service quality and reliability</li>
              <li>To process payments for Pro tier subscribers</li>
              <li>To communicate service updates and changes</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-bold tracking-tight mb-3">3. Data Storage</h2>
          <div className="bg-card border rounded-xl p-5 space-y-3 text-sm text-secondary-foreground leading-relaxed">
            <p>
              Logo images and brand data are cached on our global edge network (object storage, edge database, and key-value namespace). Request logs are retained for 30 days for operational purposes.
            </p>
            <p>
              All data is transmitted over HTTPS. We do not sell, rent, or share your personal information with third parties except as necessary to provide the service (e.g., payment processing).
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-bold tracking-tight mb-3">4. Third-Party Services</h2>
          <div className="bg-card border rounded-xl p-5 space-y-3 text-sm text-secondary-foreground leading-relaxed">
            <p>
              LoadLogo uses the following third-party services to operate:
            </p>
            <ul className="list-disc list-inside space-y-1.5 pl-2">
              <li>Edge CDN: Infrastructure and edge computing</li>
              <li>Firecrawl: Web scraping for logo and brand data extraction</li>
              <li>CoinGecko: Cryptocurrency data and logos</li>
              <li>OpenRouter: AI-powered brand resolution and description generation</li>
            </ul>
            <p>
              Each third-party service has its own privacy policy governing how they handle data.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-bold tracking-tight mb-3">5. Cookies</h2>
          <div className="bg-card border rounded-xl p-5 text-sm text-secondary-foreground leading-relaxed">
            <p>
              The LoadLogo website does not use tracking cookies. Our infrastructure provider may set essential security cookies to protect against abuse. No analytics or advertising cookies are used.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-bold tracking-tight mb-3">6. Your Rights</h2>
          <div className="bg-card border rounded-xl p-5 space-y-3 text-sm text-secondary-foreground leading-relaxed">
            <p>
              You have the right to request access to, correction of, or deletion of your personal data. To exercise these rights, contact us at hello@loadlogo.com.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-bold tracking-tight mb-3">7. Contact</h2>
          <div className="bg-card border rounded-xl p-5 text-sm text-secondary-foreground leading-relaxed">
            <p>
              For privacy-related questions, contact us at <a href="mailto:hello@loadlogo.com" className="text-primary hover:underline">hello@loadlogo.com</a>.
            </p>
          </div>
        </section>
      </div>
    </PageLayout>
  );
}
